import { Directive, HostListener } from '@angular/core';

@Directive()
export abstract class BaseCanDeactivateComponent {
	@HostListener('window:beforeunload', ['$event'])
	unloadNotification($event: BeforeUnloadEvent): void {
		if (!this.canDeactivate()) {
			$event.returnValue = true;
		}
	}

	abstract canDeactivate(): boolean;
}
